import { render, staticRenderFns } from "./GuestBoxKids.vue?vue&type=template&id=092961a3&scoped=true&"
import script from "./GuestBoxKids.vue?vue&type=script&lang=js&"
export * from "./GuestBoxKids.vue?vue&type=script&lang=js&"
import style0 from "./GuestBoxKids.vue?vue&type=style&index=0&id=092961a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092961a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('092961a3')) {
      api.createRecord('092961a3', component.options)
    } else {
      api.reload('092961a3', component.options)
    }
    module.hot.accept("./GuestBoxKids.vue?vue&type=template&id=092961a3&scoped=true&", function () {
      api.rerender('092961a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4kyjKXULHXasP/JS/comp/GuestBoxKids.vue"
export default component.exports